import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TheatersList from "../components/TheatersList";
import { Context } from "../App";
import DatePicker from "../components/DatePicker";
import { Button, Form } from "react-bootstrap";
import * as Constants from "../api/constants";
import axios from "axios";
import Toaster from "../components/Toaster";
import { enrichSlotFromTheatre } from "../utils/slotGuests";
import { getFirstSelectableSlotIndex } from "../utils/slotAvailability";
import { toDateInputValue } from "../utils/eventDate";
import { loadPersistedAddonMeta } from "../utils/bookingFlowStorage";
import { mergeSlotWithOffer } from "../utils/slotTimeOffers";
import { useCms } from "../context/CmsContext";
import "../partyBossTheme.css";

const SelectTheater = ({
  onContinueToDetails,
  theatersLoading = false,
  theatersError = null,
  theaters = null,
}) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [toasterDetails, setToasterDetails] = useState(null);
  const navigate = useNavigate();
  const formRef = useRef(null);
  const quickTheatreConsumed = useRef(false);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    eventDate: "",
    noOfGuests: 2,
    preferredTime: "Morning (9:00 AM to 12:00 PM)",
    mobileNumber: "",
    email: "",
    notes: "",
  });

  const handleReset = () => {
    formRef.current?.reset();
    setValidated(false);
  };

  const chngFn = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submitFn = (event) => {
    const form = document.getElementById("viacall_form");
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      handleBookViaApiClick();
    }
    setValidated(true);
  };

  const handleBookViaApiClick = () => {
    setShowSpinner(true);
    const modalCloseBtn = document.getElementById("modal-close-btn");
    axios
      .post(Constants.BOOK_VIA_CALL, { ...formData })
      .then((response) => {
        const { message } = response?.data;
        setShowSpinner(false);
        setToasterDetails({
          variant: "Success",
          message: `${message}`,
        });
        document.getElementById("requestCallBackLabel")?.scrollIntoView();
        handleReset();
        setTimeout(() => {
          setToasterDetails(null);
          modalCloseBtn?.click();
          navigate("/");
        }, 3000);
      })
      .catch((error) => {
        console.log(error);
        setShowSpinner(false);
        setToasterDetails({
          variant: "Danger",
          message:
            error?.response?.data?.message ||
            "Unable to Book the Event via call please try again",
        });
        document.getElementById("requestCallBackLabel")?.scrollIntoView();
      });
  };

  const {
    theatersList,
    setselectedTheaterByDate,
    setTotalCost,
    SetSelectedTime,
    context,
  } = useContext(Context);

  const { cms } = useCms();
  const b = cms.booking;

  const currentDate = new Date().toISOString().split("T")[0];

  const displayTheaters =
    Array.isArray(theaters) && theaters.length > 0
      ? theaters
      : Array.isArray(theatersList)
        ? theatersList
        : [];

  const handleConfirmTheater = (theater, slotIndex = 0) => {
    const slot =
      theater?.timeslots?.[slotIndex] ?? theater?.timeslots?.[0];
    setselectedTheaterByDate(theater);
    if (slot) {
      const eventDay = toDateInputValue(context?.eventDate);
      const offers = loadPersistedAddonMeta()?.slotOffers ?? [];
      const enriched = enrichSlotFromTheatre(slot, theater);
      const merged = mergeSlotWithOffer(enriched, theater.id, eventDay, offers);
      SetSelectedTime(merged);
      setTotalCost(merged.basePrice ?? theater?.basePrice ?? 0);
    }
    if (typeof onContinueToDetails === "function") {
      onContinueToDetails();
    } else {
      navigate("/booknow/booking-form");
    }
  };

  // Deep-link from /quick-book: auto advance once a matching theatre appears in search results.
  useEffect(() => {
    if (quickTheatreConsumed.current || theatersLoading || displayTheaters.length === 0) return;
    let raw;
    try {
      raw = sessionStorage.getItem("pb_quick_theatre_id");
    } catch {
      return;
    }
    if (!raw) return;
    const tid = Number(String(raw).trim());
    if (!Number.isFinite(tid)) return;
    const t = displayTheaters.find((th) => Number(th?.id ?? th?.theatreId) === tid);
    if (!t) return;
    try {
      sessionStorage.removeItem("pb_quick_theatre_id");
    } catch {
      /* ignore */
    }
    quickTheatreConsumed.current = true;
    const eventDay = toDateInputValue(context?.eventDate);
    const slotIx = getFirstSelectableSlotIndex(t.timeslots, eventDay);
    if (slotIx < 0) return;
    handleConfirmTheater(t, slotIx);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot pick from QR; avoid re-running on every slot change
  }, [theatersLoading, displayTheaters.length, context?.eventDate]);

  const onreset = () => {
    setTotalCost(0);
  };

  return (
    <section className="party-boss-page w-full bg-[#05020a] pb-10 pt-0 text-white selection:bg-pink-500/40 md:pb-14">
      <div className="party-boss-bg relative z-10">
        <div className="mx-auto w-full max-w-[min(100%,92rem)] px-3 sm:px-5 md:px-8 lg:px-10">
          <div className="rounded-2xl bg-white/[0.035] p-3 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.06)] sm:p-5 md:p-6 lg:p-7">
            <h1 className="mb-3 text-center text-sm font-black uppercase tracking-[0.2em] text-[#ffd166] sm:mb-4 sm:text-base">
              {b.panelTitle}
            </h1>
            <DatePicker
              onDateChange={onreset}
              variant="partyBoss"
            />
            <div className="mt-6 md:mt-8">
          {theatersLoading ? (
            <div className="rounded-xl bg-white/5 p-8 text-center md:p-10">
              <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-[#ffd166] border-t-transparent" />
              <p className="font-semibold text-white">
                {b.loadingTitle}
              </p>
              <p className="mt-2 text-sm text-[#c9c1d9]">
                {b.loadingSubtitle}
              </p>
            </div>
          ) : theatersError ? (
            <div className="rounded-xl bg-red-950/40 p-8 text-center md:p-10">
              <p className="font-bold text-red-200">{theatersError}</p>
              <p className="mt-2 text-sm text-red-200/80">
                {b.errorSubtitle}
              </p>
            </div>
          ) : Array.isArray(displayTheaters) && displayTheaters.length > 0 ? (
            <TheatersList
              TheatersList={displayTheaters}
              getTheaterDetails={handleConfirmTheater}
            />
          ) : (
            <div className="rounded-xl bg-white/5 p-8 text-center text-[#c9c1d9] md:p-10">
              {b.emptyState}
            </div>
          )}
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-center px-[4%] md:mt-8">
          <button
            type="button"
            className="rounded-full border border-white/20 bg-white/10 px-6 py-3 font-bold text-white transition hover:bg-white/20"
            data-bs-toggle="modal"
            data-bs-target="#requestCallBack"
          >
            <i className="bi bi-telephone-outbound-fill me-2"></i>
            {b.bookViaCallLabel}
          </button>
        </div>
      </div>

      <div
        className="modal fade"
        id="requestCallBack"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="requestCallBackLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title fs-4 logo-color-1" id="requestCallBackLabel">
                Request Callback
              </h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="modal-close-btn"
              ></button>
            </div>
            <div className="modal-body">
              {toasterDetails && <Toaster details={toasterDetails} />}
              <Form
                ref={formRef}
                noValidate
                validated={validated}
                onSubmit={submitFn}
                id="viacall_form"
              >
                <Form.Group className="mb-3">
                  <Form.Label>Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter name"
                    value={formData.name}
                    required
                    onChange={chngFn}
                    pattern="^[a-zA-Z\s]+$"
                    maxLength={20}
                    isInvalid={
                      validated && !/^[a-zA-Z\s]+$/.test(formData.name)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid name.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Select date</Form.Label>
                  <Form.Control
                    type="date"
                    name="eventDate"
                    min={currentDate}
                    value={formData.eventDate || currentDate}
                    onChange={chngFn}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Number of Person(s)</Form.Label>
                  <Form.Select
                    name="noOfGuests"
                    value={formData.noOfGuests}
                    onChange={chngFn}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Time Preference</Form.Label>
                  <Form.Select
                    name="preferredTime"
                    value={formData.preferredTime}
                    onChange={chngFn}
                  >
                    <option>Morning (9:00 AM to 12:00 PM)</option>
                    <option>Afternoon (12:30 PM to 3:30 PM)</option>
                    <option>Evening (4:00 PM to 7:00 PM)</option>
                    <option>Night (7:30 PM to 10:30 PM)</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    WhatsApp Number (10 digit Indian number) *
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={chngFn}
                    pattern="^\d{10}$"
                    placeholder="10-digit mobile"
                    required
                    isInvalid={
                      validated && !/^\d{10}$/.test(formData.mobileNumber)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid 10-digit phone number.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={chngFn}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Special notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    value={formData.notes}
                    onChange={chngFn}
                  />
                </Form.Group>
              </Form>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <Button
                type="submit"
                className="btn btn-primary btn-color-1"
                id="bookViaCallSubmitBtn"
                onClick={submitFn}
                disabled={showSpinner}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectTheater;
